import React, { useContext } from 'react';
import Select from 'react-select-v3';
import CarriersContext from '../context';
import { connect } from 'react-redux';
import { getFilteredRoutes } from 'reselects';
import style from '../style.module.scss';
import { reactSelectStyles } from '../../../components/ShipmentFilters/styled/index.js';
import useCarriersLite from 'utils/hooks/useCarriersLite';

const CarrierHomeFilters = ({ t, routes }) => {
  const {
    periodFilter,
    setPeriodFilter,
    routesFilter,
    setRoutesFilter,
    categoryFilter,
    setCategoryFilter,
    carrierTypeFilter,
    setCarrierTypeFilter,
    statusFilter,
    setStatusFilter,
    loading,
  } = useContext(CarriersContext);
  const { isCategoryDisabled, isCarrierTypeDisabled } = useCarriersLite();

  const dateOptions = [
    { label: t.date.last_week, value: 'last_week' },
    { label: t.date.last_month, value: 'last_month' },
    { label: t.date.last_three_months, value: 'last_three_months' },
    { label: t.date.last_six_months, value: 'last_six_months' },
    { label: t.date.any, value: '' },
  ];

  const statusOptions = [
    { label: t.status.active, value: 'active' },
    { label: t.status.not_activated, value: 'not_activated' },
    { label: t.status.banned, value: 'banned' },
    { label: t.status.any, value: '' },
  ];

  const typeOptions = [
    { label: t.type.owner_operator, value: 'Owner Operator' },
    { label: t.type.small_fleet, value: 'Small Fleet' },
    { label: t.type.medium_fleet, value: 'Medium Fleet' },
    { label: t.type.big_fleet, value: 'Big Fleet' },
    { label: t.type.no_active_vehicles, value: 'No active vehicles' },
  ];

  const categoryOptions = [
    { label: 'T1', value: 'T1' },
    { label: 'Potential T1', value: 'Potential T1' },
    { label: 'T2', value: 'T2' },
    { label: 'T3', value: 'T3' },
    { label: 'Churn', value: 'churn' },
    { label: 'FTC', value: 'FTC' },
    { label: 'RTL', value: 'RTL' },
    { label: 'LH', value: 'LH' },
  ];

  const mappedRoutes = routes
    .map((route) => ({ value: route.name.replace('-', '->'), label: route.simple_name }))
    .map(({ value, label }) => ({ value, label }));

  return (
    <div className={style.filtersContainer}>
      <Select
        options={mappedRoutes}
        placeholder={t.route}
        isMulti
        onChange={(selectedOption) => setRoutesFilter(selectedOption)}
        styles={reactSelectStyles}
        containerWidth="auto"
        isDisabled={loading}
        value={routesFilter || ''}
      />
      {!isCarrierTypeDisabled && (
        <Select
          options={typeOptions}
          isMulti
          placeholder={t.carrier_type}
          onChange={(selectedOption) => {
            setCarrierTypeFilter(selectedOption);
          }}
          styles={reactSelectStyles}
          containerWidth="auto"
          isDisabled={loading}
          value={carrierTypeFilter || ''}
        />
      )}
      {!isCategoryDisabled && (
        <Select
          options={categoryOptions}
          isMulti
          placeholder={t.category}
          onChange={(selectedOption) => setCategoryFilter(selectedOption)}
          styles={reactSelectStyles}
          containerWidth="auto"
          isDisabled={loading}
          value={categoryFilter || ''}
        />
      )}
      <Select
        options={dateOptions}
        onChange={(selectedOption) => setPeriodFilter(selectedOption.value)}
        placeholder={t.last_job}
        styles={reactSelectStyles}
        containerWidth="auto"
        isDisabled={loading}
        value={dateOptions.find((item) => item.value === periodFilter) || ''}
      />
      <Select
        options={statusOptions}
        placeholder={t.carrier_status}
        onChange={(selectedOption) => setStatusFilter(selectedOption.value)}
        styles={reactSelectStyles}
        containerWidth="auto"
        isDisabled={loading}
        value={statusOptions.find((item) => item.value === statusFilter) || ''}
      />
    </div>
  );
};

export default connect((state) => {
  return {
    routes: getFilteredRoutes(state, (route) => route.defined),
  };
})(CarrierHomeFilters);
